import React from "react";
import Tag from "./Tag";

const TagList = (props: { version: "short" | "long", tags: server.dto.TagSmall[] }) => {
  const { tags } = props;

  if (tags.length === 0) return null;

  return (
    <div className="tag-list">
      {tags.map((t) => <Tag
        key={t.tagId}
        title={t.title}
        label={t.code}
        color={t.hexColor} />)}
    </div>
  );
};

export default TagList;